export default "__VITE_ASSET__C4vb4$jb__"